import ButtonIcon from "../common/buttonIcon"
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect, useState } from "react";
import { debounce } from "lodash";

const Pagination = (props: any) => {
  const { t } = useTranslation();
  const [pageIndex, setPageIndex] = useState(props.pageIndex);
  const [pageTotal, setPageTotal] = useState(props.pageTotal);
  const [params, setParams] = useState({});

  useEffect(() => {
    setPageTotal(props.pageTotal);
  }, [props.pageTotal]);

  useEffect(() => {
    setPageIndex(props.pageIndex);
  }, [props.pageIndex]);

  useEffect(() => {
    setParams({ pageIndex, pageTotal });
  }, [pageIndex, pageTotal]);

  const changePage = (newPageIndex: number) => {
    setPageIndex(newPageIndex);
    onPageChange(newPageIndex);
  };

  const onPageChange = useCallback(
    debounce(
      (newPageIndex: number) => {
        props.onPageChange(newPageIndex);
      },
      500
    ),
    []
  );

  return (
    <>
      <div className=" text-lg-right ">
        <div className="Pagination">
          <h6>{t("page-label", params)}</h6>
          <ButtonIcon disabled={(pageIndex === 1)} handleClick={() => changePage(pageIndex - 1)} icon="keyboard_arrow_left" />
          <ButtonIcon disabled={(pageIndex === pageTotal)} handleClick={() => changePage(pageIndex + 1)} icon="keyboard_arrow_right" />
        </div>
      </div>
    </>
  )
}

export default Pagination